import React from "react";
import { Link } from "react-router-dom";

function Blog({ blog: { title, date, author, slug, topics } }) {
  return (
    <div className="blog-item">
      <div className="row-center">
        <div className="thumb f1">
          <img src={"/images/git.png"} className="git-image" alt={title} />
        </div>
        <p className="mb-0 f10">
          <Link to={{ pathname: slug }} target="_blank">
            {title}
          </Link>
        </p>
      </div>
      <ul className="list-inline meta mb-0 mt-2">
        <li className="list-inline-item">{date}</li>
        <li className="list-inline-item">{author}</li>
      </ul>
      <ul className="row-list">
        {topics.map((item) => (
          <li className="pills">{item}</li>
        ))}
      </ul>
    </div>
  );
}

export default Blog;
